"use client"
import { createContext, useContext, useState, useEffect, useCallback } from "react"
import { apiRequest } from '../utils/apiRequest'

const TransactionContext = createContext(undefined)

export const TransactionProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)
  const [transactions, setTransactions] = useState([])
  const [sortOrder, setSortOrder] = useState("default")
  const [currentPage, setCurrentPage] = useState(1)
  // One page size, used as both the initial request and the default for any
  // caller that omits it. The refresh and search handlers called
  // getTransactions() with no size, which fell back to a hardcoded 4 and made
  // the list silently shrink from 10 rows to 4 after a refresh or a search.
  const DEFAULT_PAGE_SIZE = 10

  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const [total,setTotal] = useState(0)
  const [searchPhrase, setSearchPhrase] = useState('')
  const [dateRange, setDateRange] = useState(null)
  const [typeFilter, setTypeFilter] = useState(null)

  const getTransactions = useCallback(async (s, pageSize = DEFAULT_PAGE_SIZE, currentPage = 1, filters = {}) => {
    try {
      setLoading(true)
      let url = `/transactions`;
      const params = new URLSearchParams();
      if (pageSize && !isNaN(pageSize) && pageSize > 0) {params.append('limit', pageSize)}
      if (currentPage) { params.append('page', currentPage);}
      if (s) { params.append('search', s);}
      if (filters.from) { params.append('from', filters.from); }
      if (filters.to) { params.append('to', filters.to); }
      if (filters.type) { params.append('type', filters.type); }
      params.append('sortorder', 'desc');
      url += `?${params.toString()}`;

      const response = await apiRequest({
        method: "get",
        url,
      });

      if (response.data) {
        setTransactions(response.data.data);
         response.data.pagination.total && setTotal(response.data.pagination.total )
        setPageSize(response.data.pagination.perPage)
      }
      return response;
    } catch (error) {
      console.error(error);
      return { success: false, error };
    } finally {
      setLoading(false)
    }
  }, []);

  return (
    <TransactionContext.Provider 
      value={{ 
        transactions,
        getTransactions,
        loading,
        searchPhrase,
        setSearchPhrase,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        total,
        setTotal,
        dateRange,
        setDateRange,
        typeFilter,
        setTypeFilter,
        DEFAULT_PAGE_SIZE
      }}
    >
      {children}
    </TransactionContext.Provider>
  )
}

export const useTransactions = () => {
  const context = useContext(TransactionContext)
  if (context === undefined) {
    throw new Error("useTransaction must be used within a TransactionProvider")
  }
  return context
}